import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import ClaimsPage from '@/pages/ClaimsPage';
import CATModePage from '@/pages/CATModePage';
import ReserveReviewPage from '@/pages/ReserveReviewPage';
import RecoveriesPage from '@/pages/RecoveriesPage';
import DischargeAgingPage from '@/pages/DischargeAgingPage';
import StaleReassignPage from '@/pages/StaleReassignPage';
import HandlerQueuePage from '@/pages/HandlerQueuePage';
import { useAuth } from '@/contexts/AuthContext';

export default function ClaimsModule() {
  const { user } = useAuth();
  const isAdmin = ['mga_admin', 'platform_owner'].includes(user?.role) || !!user?.claims_lead;
  const isObserver = ['regulator', 'investor'].includes(user?.role);
  const myQueue = { id: 'my-queue', label: 'My Queue', content: <HandlerQueuePage /> };
  const tabs = [
    ...(user?.role === 'claims_handler' ? [myQueue] : []),
    { id: 'active', label: 'All Claims', content: <ClaimsPage /> },
    ...(!isObserver && user?.role !== 'claims_handler' ? [myQueue] : []),
    { id: 'reserving', label: 'Reserve Review', content: <ReserveReviewPage /> },
    { id: 'recoveries', label: 'Recoveries', content: <RecoveriesPage /> },
    { id: 'discharges', label: 'Discharges', content: <DischargeAgingPage /> },
    { id: 'cat-mode', label: 'CAT Mode', content: <CATModePage /> },
    ...(isAdmin ? [{ id: 'reassign', label: 'Reassign Sweep', content: <StaleReassignPage /> }] : []),
  ];

  return (
    <ModuleShell title="Claims" subtitle="FNOL through settlement" tabs={tabs} />
  );
}
